export default "/build/frontend/fonts/vendor/@fontsource/inter/files/inter-latin-ext-400-normal.woff2?3d10c85fbd16969509a231103b558b9d";